<template>
    <Modal
        :show="confirm.showConfirm"
        :title="confirm.confirmTitle"
        style-class="modal-sm"
        :class="confirm.styleClass"
        :esc-handler="cancel"
        :enter-handler="ok"
        @close="cancel"
    >
        <p v-if="typeof confirm.confirmBody === 'string'">{{ confirm.confirmBody }}</p>
        <template v-else-if="Array.isArray(confirm.confirmBody)">
            <p v-for="(part, index) in confirm.confirmBody" :key="index">{{ part }}</p>
        </template>
        <button ref="okbtn" v-focus-updated class="btn btn-ok" @click="ok">{{ confirm.confirmOk }}</button>
        <button v-if="confirm.confirmCancel" class="btn btn-cancel" @click="cancel">
            {{ confirm.confirmCancel }}
        </button>
    </Modal>
</template>

<script type="text/babel">
import Modal from './Modal.vue';
import { mapState, mapActions } from 'vuex';
import commonDirectives from './commonDirectives';

export default {
    name: 'Confirmation',

    components: {
        Modal,
    },

    mixins: [commonDirectives],

    computed: {
        ...mapState({
            confirm: state => state.confirm,
        }),
    },

    watch: {
        $route() {
            this.hide();
        },
    },

    updated() {
        if (this.$refs.okbtn) {
            this.$refs.okbtn.focus();
        }
    },

    methods: {
        ...mapActions({
            ok: 'confirm/ok',
            cancel: 'confirm/cancel',
            hide: 'confirm/hide',
            addOnKeyDownHandler: 'addOnKeyDownHandler',
            removeOnKeyDownHandler: 'removeOnKeyDownHandler',
        }),

        confirmation(modalTitle, modalBody, okText, cancelText, styleClass) {
            this.confirmTitle = modalTitle;
            this.confirmBody = modalBody;
            this.confirmOk = okText;
            this.confirmCancel = cancelText;
            this.styleClass = styleClass;
            return new Promise((resolve, reject) => {
                this.resolveHandler = resolve;
                this.rejectHandler = reject;
            });
        },
    },
};
</script>
